import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/blog-authors`;

export const createBlogAuthor = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteBlogAuthor = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateBlogAuthor = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
